<script setup lang="ts">
import useClient from "@/api/client";
import useCommand from "@/composables/useCommand";
import { ButtonNormal, ModalDelete } from "lorga-ui";
import { toRefs } from "vue";

const props = defineProps<{
  query: () => void;
  wochenplanId: string;
}>();
const { query } = toRefs(props);

const client = useClient();

const { request } = client.post("/command/");
const { commandRequest, commandModalOpen } = useCommand(request, query.value);
</script>

<template>
  <ButtonNormal kind="delete" @click="commandModalOpen = true">
    Wochenplan Löschen
  </ButtonNormal>
  <ModalDelete
    v-model="commandModalOpen"
    title="Wochenplan Löschen"
    submit="Löschen"
    :request="commandRequest"
    :data="{
      action: 'wochenplan.loeschen',
      wochenplan_id: wochenplanId,
    }"
  >
    Willst du wirklich den Wochenplan löschen?
  </ModalDelete>
</template>
